import HttpClient from '../../../services/http-client';
import { serialize } from 'object-to-formdata';
import { IAttachmentResponse } from '../../../../model/sge/attachment/response/attachment-response';
import { IAttachmentUploadRequest } from '../../../../model/sge/attachment/request/attachment-upload-request';

const list = async (entityType: string, entityId: number): Promise<IAttachmentResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/Attachment/${entityType}/${entityId}`
    }).then((response) => response.data);
};

const upload = async (params: IAttachmentUploadRequest): Promise<void> => {
    const formData = serialize({ title: params.title || params.file.name, fileType: params.file.type || 'application/octet-stream' }, { indices: false });
    formData.append('file', params.file);
    await HttpClient.executeRequest({
        method: 'post',
        url: `/Attachment/${params.entityType}/${params.entityId}`,
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' }
    });
};

const download = async (id: number): Promise<Blob> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/Attachment/${id}/Download`,
        responseType: 'blob'
    }).then((response) => response.data);
};

const remove = async (id: number): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'delete',
        url: `/Attachment/${id}`
    });
};

const AttachmentAppService = { list, upload, download, remove };
export default AttachmentAppService;
